<template>
	<v-container
		class="brightBackground"
		fluid
		style="min-height: 100%"
	>
		
		<v-container fluid style="max-width: 1000px;" class="pt-xs-0 pt-sm-0 pt-md-0 pt-lg-6">

			<v-row>

				<v-col class="pt-0 pa-0 ma-0">
					
					<v-subheader v-if="routeState === 'active'" class="display-1 font-weight-bold ml-0 pl-1 pb-0 grey--text text--darken-3">Active users</v-subheader>
					<v-subheader v-if="routeState !== 'active'" class="display-1 font-weight-bold ml-0 pl-1 pb-0 mb-2" style="color: #4e1e1e;">Disabled users</v-subheader>

					<v-toolbar v-if="routeState === 'active'" 
						dense
						flat
						color="toolbarSecondary"
					>
						<v-btn
							color="iconTextColor"
							text
							small
							style="text-transform: none;"
							class="ml-n4"
							height="32"
							router to="/admin/newuser"
						>
							<v-icon medium>mdi-account-plus</v-icon>
							<span class="ml-2">Add new user</span>
						</v-btn>

						<v-spacer/>

						<v-btn small icon @click="getUserList">
							<v-icon medium>mdi-refresh</v-icon>
						</v-btn>

					</v-toolbar>



					<v-card
						color="boxOnBrightBackground"
						flat
						class="pa-3 mb-4"
					>
						<!-- -------------------------------------------- -->
						<!--   Table header names -->
						<!-- -------------------------------------------- -->

						<div align="left" class="d-none d-md-block" style="height: 26px">
							<div
								style="position: absolute; cursor: pointer;"
								class="subtitle-2 primary--text text--darken-3 pb-1 pl-6 d-none d-md-block"
								@click="agile.sortBy(userList, 'name'); lastSortedBy = 'name'"
							>Name
							</div>

							<div
								style="position: absolute; left: 32%; cursor: pointer;"
								class="subtitle-2 primary--text text--darken-3 d-none d-md-block"
								@click="agile.sortBy(userList, 'email'); lastSortedBy = 'email'"
							>Email
							</div>

							<div
								style="position: absolute; left: 66%; cursor: pointer;"
								class="subtitle-2 primary--text text--darken-3 d-none d-md-block"
								@click="agile.sortBy(userList, 'clientsListedforTitle'); lastSortedBy = 'clientsListedforTitle'"
							>Access
							</div>

						</div>

						<!-- -------------------------------------------- -->
						<!--   Expansion panel -->
						<!-- -------------------------------------------- -->

						<v-expansion-panels multiple v-model="panel">

							<v-expansion-panel 
								v-for="(user, id) in userList"
								:key="id"
							>
								<!-- Expanded panel header-->
								<v-expansion-panel-header style="height: 48px; font-size: 14px;" color="grey lighten-4 grey--text text--darken-4">
									<span style="font-weight: 500;">{{ user.name }}</span>
									<div class="d-none d-md-block" style="position:absolute; left: 32%">{{ user.email }}</div>
									<div class="d-none d-md-block" style="position:absolute; left: 66%">{{ user.clientsListedforTitle }}</div>
									
								</v-expansion-panel-header>

								<!-- Expanded panel -->
								<v-expansion-panel-content>
									<v-container fluid class="pt-4 pb-0 px-1">
										
										<!-- Form -->
										<v-form :ref="'editUserForm'+user.n">

											<v-row>
												<v-col cols="12" lg="5" xl="5" style="background-colorr: #CCFFCC">

													<v-row>

														<v-col cols="12" class="title px-3 pb-3 pt-0 mt-n2">
															User info
														</v-col>
														
														<v-col cols="12" class="px-3 pb-0">

															<v-text-field
																label="First name"
																v-model="user.firstName"
																class="mt-n3"
																outlined
																dense
																required
																validate-on-blur
															></v-text-field>

														</v-col>
														
														<v-col
															cols="12"  class="px-3 pb-0"
														>
															<v-text-field
																label="Last name *"
																v-model="user.lastName"
																:rules="agile.fieldRules.nameRules"
																class="mt-n3"
																outlined
																dense
																required
																validate-on-blur
															></v-text-field>
														</v-col>

														<v-col
															cols="12"  class="px-3 pb-0"
														>
															<v-text-field
																label="Email *"
																v-model="user.email"
																:rules="agile.fieldRules.emailRules"
																class="mt-n3"
																outlined
																dense
																required
																validate-on-blur
															></v-text-field>
														</v-col>
														
													</v-row>
												</v-col>

												<v-col cols="12" lg="7" xl="7" class="px-3 pb-0" style="background-colorr: #CCCCFF" v-if="user.customClaims.accessCards.length > 0">
													
													<!-- -------------------------------------------- -->
													<!--   Access cards -->
													<!-- -------------------------------------------- -->

													<v-row>

														<v-col cols="12" class="title px-3 pb-0 pt-0 mt-n2">
															Access cards
														</v-col>

														<v-col class="pl-5 pr-5 pt-0">
															<v-row>

																<v-col
																	cols="12" md="6" xl="6"
																	class="px-1 pb-0 mb-n1"
																	v-for="accessCard in user.customClaims.accessCards"
																	:key="(!!accessCard.key) ? accessCard.key : 'missing'"
																>
																	
																	<div style="width: 100%; height: 70px; border-radius: 4px; position: relative;" class="brightBackground">

																		<div class="ai-user-access-card elevation-1">
																			<div class="ai-user-access-card-stripe"/>
																			<div class="ai-user-access-card-inner">
																			{{ getReadableAccessLevel(accessCard.l) }}
																			</div>
																		</div>
																		
																		<div class="ai-user-access-card-textbox" style="position:absolute; left: 65px; width: 100%;">
																			<div style="height: 19px;">{{ accessCard.clientName }}</div>
																			<div style="height: 19px;">{{ (accessCard.groupName == "*") ? "All project groups" : accessCard.groupName }}</div>
																			<div style="height: 19px;">{{ (accessCard.projectName == "*") ? "All projects" : accessCard.projectName }}</div>
																		</div>

																		<v-btn
																			v-if="user.id !== agile.loggedInUser.uid"
																			icon
																			style="position: absolute; top: -5px; right: -7px;"
																			@click="deleteAccessCard(user.id, accessCard)"
																			:class="(accessCard.l == 'super') ? 'd-none' : ''"
																		>
																			<v-icon small color="grey">mdi-close</v-icon>
																		</v-btn>

																	</div>
																	
																</v-col>

															</v-row>    
														</v-col>
														
													</v-row>

												</v-col>
												
											</v-row>


											<!-- -------------------------------------------- -->
											<!--   Bottom menu -->
											<!-- -------------------------------------------- -->

											<v-row class="mb-n3">


												<!-- -------------------------------------------- -->
												<!--   Drop down -->
												<!-- -------------------------------------------- -->
												<v-col align="left" cols="2" class="pl-0 ml-n4">

													<v-menu offset-y>
														<template v-slot:activator="{ on }">
															<v-btn v-on="on" color="iconTextColor" style="text-transform: none;" class="px-1 ml-3" small text>
																<v-icon medium class="pr-1">mdi-dots-vertical</v-icon>
																More actions
															</v-btn>
															<!-- <icon-text-button v-on="on" class="px-1 ml-3" b-icon="mdi-dots-vertical"> More actions</icon-text-button> -->
														</template>

														<v-list dense>
															
															<!-- Delete user -->
															<v-list-item v-if="routeState !== 'active'" @click="deleteUsers([user.id])">           
																<v-list-item-icon>
																	<v-icon>mdi-delete</v-icon>
																</v-list-item-icon>

																<v-list-item-content class="ml-n4">
																	<v-list-item-title>Permanently delete user</v-list-item-title>
																</v-list-item-content>
															</v-list-item>
															
															<!-- Disable user -->
															<v-list-item v-if="routeState === 'active' && user.id !== agile.loggedInUser.uid" @click="disableUsers([user.id])">           
																<v-list-item-icon>
																	<v-icon>mdi-delete</v-icon>
																</v-list-item-icon>

																<v-list-item-content class="ml-n4">
																	<v-list-item-title>Disable user</v-list-item-title>
																</v-list-item-content>
															</v-list-item>

															<!-- Reset form -->
															<v-list-item v-if="agile.loggedInUser.superAdmin">
																<v-list-item-icon>
																	<v-icon>mdi-backup-restore</v-icon>
																</v-list-item-icon>

																<v-list-item-content class="ml-n4">
																	<v-list-item-title>Revert form</v-list-item-title>
																</v-list-item-content>
															</v-list-item>

															<!-- Reset password -->
															<v-list-item>           
																<v-list-item-icon>
																	<v-icon>mdi-lock-reset</v-icon>
																</v-list-item-icon>

																<v-list-item-content class="ml-n4">
																	<v-list-item-title>Reset password</v-list-item-title>
																</v-list-item-content>
															</v-list-item>

															<!-- Make super admin -->
															<v-list-item v-if="agile.loggedInUser.superAdmin" @click="makeSuperAdmin(user.id)">
																<v-list-item-icon>
																	<v-icon>mdi-account-tie</v-icon>
																</v-list-item-icon>

																<v-list-item-content class="ml-n4">
																	<v-list-item-title>Make super admin</v-list-item-title>
																</v-list-item-content>
															</v-list-item>
															

														</v-list>
													</v-menu>


												</v-col>

												<v-col align="right">
													<!-- <v-btn style="text-transform: none;" class="px-1 ml-3" small text @click="openChooseProject(user.id)">
														<v-icon medium class="pr-1">mdi-credit-card-outline</v-icon>
														Add access card
													</v-btn>
													<v-btn style="text-transform: none;" class="px-1 ml-3" small text @click="saveUser(user)">
														<v-icon medium class="pr-1">mdi-content-save</v-icon>
														Save changes
													</v-btn> -->
													<!-- <v-btn color="iconTextColor" style="text-transform: none;" class="px-1 ml-3" small text @click="enableUsers([user.id])">
														<v-icon medium class="pr-1">mdi-backup-restore</v-icon>
														Enable user
													</v-btn> -->
													<icon-text-button v-if="routeState !== 'active'" class="px-1 ml-3" b-icon="mdi-backup-restore" @click="enableUsers([user.id])">Enable user</icon-text-button>
													<icon-text-button v-if="user.id !== agile.loggedInUser.uid" class="px-1 ml-3" b-icon="mdi-credit-card-outline" @click="openChooseProject(user.id)">Add access card</icon-text-button>
													<icon-text-button class="px-1 ml-3" b-icon="mdi-content-save" @click="saveUser(user)">Save changes</icon-text-button>
												</v-col>
											</v-row>

										</v-form>
									</v-container>

								</v-expansion-panel-content>
							</v-expansion-panel>

						</v-expansion-panels>

					</v-card>

				</v-col>
			</v-row>
			
		</v-container>

		<ChooseProjectForAccess ref="chooseProject"  @access-card-added="handleAccessCardAdded" />

	</v-container>
</template>



<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from '@/shift/agile';
import agileFb from '@/shift/agileFb';
import fb from '@/shift/fb';
import ChooseProjectForAccess from '@/components/ChooseProjectForAccess'

export default
{
	name: 'Users',

	// ----------------------------------
	//	VUE: Data and computed
	// ----------------------------------

	data: () =>
	({
		// V-model for expansion panel
		panel: [],

		// Data consisting of users to be in the List component
		userList: [],

		// Which array of users are seletec in the table? (not really in use at the moment)
		selectedUsers: [],

		lastSortedBy: 'clientsListedforTitle',

		panelIsOpening: false,

	}),

	computed:
	{
		agile()
		{
			return agile;
		},

		agileFb()
		{
			return agileFb;
		},

		routeState()
		{
			return this.$route.params.state;
		},

		/*userList()
		{
			// routeState === 'active'
			return agileFb.userList;
		},*/

	},


	// ----------------------------------------------------
	//
	//  VUE: Watch for changes in observable properties
	//
	// ----------------------------------------------------

	watch:
	{
		'agileFb.userList':
		{
			deep: true,

			handler()
			{
				//this.updateUserList();
				//this.userList = agileFb.userList;
			}
		},


		panel: function ()
		{
			// -----------------------------------------------
			//	Update data provider of expansion panels
			//  when a panel opens or closes.
			// -----------------------------------------------

			//if (this.userList) return;

			this.panelIsOpening = true;

			for (let i = 0; i < agileFb.userList.length; i++)
			{
				// Set it closed by default, but set open if it is found again in the panel list
				agileFb.userList[i].panelOpen = false;

				for (let j = 0; j < this.panel.length; j++)
				{
					// Find the open ones and update the dataprovider
					if (i === this.panel[j])
					{
						agileFb.userList[i].panelOpen = true;
						break;
					}
				}
			}

			this.panelIsOpening = false;
		},

		$route()
		{
			// This doesnt seem to happen ever, because we force refresh view on router change in MainFrame.vue (<router-view :key="$route.fullPath"></router-view>)
			//this.userList = [];
			//console.log('route change happen?');
			//this.userList = agileFb.userList;

			//this.getUserList();

			//if (this.routeState !== 'active') agile.setCurrentProjectByKey(this.routeKey);
			//this.inProjectMode = this.checkingProjectMode();
		},

		userList: function ()
		{
			//if (this.panelIsOpening) return;
			//if (this.userList) return;

			// -----------------------------------------------
			//	When userList change, i.e. it changes order
			//  or some item is removed, we need to update
			//  the this.panel v-model for the expansion panel.
			// -----------------------------------------------

			// Make a temporary list of the new panel order
			const tempPanel = [];

			for (let i = 0; i < this.userList.length; i++)
			{
				// Update the panel v-model with the correct order from the dataprovider
				if (this.userList[i].panelOpen)
				{
					tempPanel.push(i);
				}
			}

			// Update the real v-model property
			this.panel = tempPanel;

		}
	},


	// ----------------------------------------------------
	//
	//  VUE: Create and Mount
	//
	// ----------------------------------------------------

	created()
	{
		this.panel = [];
		this.getUserList();
		//this.$root.ai_app.showProgressWheel = true;
	},

	mounted()
	{
		agileFb.updateUserPageList = this.updateUserList;
		this.updateUserList();
	},


	// --------------------------------------------------------------------
	//
	//	VUE: Methods
	//
	// --------------------------------------------------------------------

	methods:
	{

		updateUserList()
		{
			//console.log('* Update users!');
			this.userList = [];

			const listDisabled = this.routeState !== 'active';

			for (let i = 0; i < agileFb.userList.length; i++)
			{
				if ( (agileFb.userList[i].disabled && listDisabled) || (!agileFb.userList[i].disabled && !listDisabled))
				{
					this.userList.push(agileFb.userList[i]);
				}
			}
		},

		// ----------------------------------
		//	When user presses save changes
		// ----------------------------------

		handleUserSaveEvent()
		{
			// Update user list after user is saved
			this.getUserList();
		},


		// ----------------------------------
		//	Delete access card
		// ----------------------------------

		deleteAccessCard(uid, accessCard)
		{
			this.$root.$confirm("Warning", "The user will lose all access to projects. Are you sure you want to remove the access card?")
			.then((confirm) =>
			{
				if (confirm)
				{

					this.$root.ai_app.showProgressWheel = true;

					const deleteUserAccessCard = fb.functions.httpsCallable('deleteUserAccessCard');

					deleteUserAccessCard( { uid: uid, key: accessCard.key } )
					.then(result =>
					{
						this.$root.ai_app.showProgressWheel = false;

						if (result.data.success)
						{
							this.$root.ai_app.snackbarText = 'User access card removed';
							this.$root.ai_app.snackbarTimeout = 4000;
							this.$root.ai_app.snackbar = true;
							
							this.getUserList();
						}
						else
						{
							this.$root.$alert("Error", result.data.error.message);
						}
						
					})
					.catch(er =>
					{
						this.$root.ai_app.showProgressWheel = false;
						this.$root.$alert("Error", er);
					});

				}
			});

		},



		// ----------------------------------
		//	Get user list
		// ----------------------------------

		getUserList()
		{
			agileFb.getUserList();
			/*const listUsers = fb.functions.httpsCallable('listUsers');

			listUsers( { filters: { disabled: (this.routeState !== 'active') } } )
			.then(result =>
			{
				this.$root.ai_app.showProgressWheel = false;

				//console.log(result);

				if (result.data.success)
				{
					
					// ------------------------------------------
					//	Before we update the dataprovider for
					//  the expandable panel, we need to remember
					//  which items that was open/expanded in the UI!
					// ------------------------------------------

					const tempItemsWasOpen = [];

					for (let i = 0; i < this.userList.length; i++)
					{
						if (this.userList[i].panelOpen) tempItemsWasOpen.push(this.userList[i].id);
					}

					
					// ---------------------------------------
					//	Ok, got them, clear list and move on
					//  to populate with new data
					// ---------------------------------------

					const tempUserList = [];
					let count = 0;

					

					// result.data.aiData is the array of users
					result.data.aiData.forEach(user =>
					{

						// ---------------------------------------
						//	Parse users and push to dataprovider
						// ---------------------------------------

						// If customClaims doesnt exist, create dummy object so UI doesn't fail
						let customClaims = (!user.auth.customClaims) ? { accessCards: [] } : user.auth.customClaims;

						// Same with accessCards
						if (!customClaims.accessCards) customClaims.accessCards = [];


						// ------------------------------------------
						//	Title bar table, we list "clients"
						// ------------------------------------------

						// Get the client names and concatenate them for the title bar 'Access' column
						let clientsForTitle = '';
						let tempArray = [];

						for (let i = 0; i < customClaims.accessCards.length; i++)
						{
							let gotDuplicate = false;
							
							customClaims.accessCards[i].clientName = agile.getClientNameByKey(customClaims.accessCards[i].key);
							customClaims.accessCards[i].groupName = agile.getGroupNameByKey(customClaims.accessCards[i].key);
							customClaims.accessCards[i].projectName = agile.getProjectNameByKey(customClaims.accessCards[i].key);

							if (customClaims.accessCards[i].clientName !== null)
							{
								for (let j = 0; j < tempArray.length; j++)
								{
									if (customClaims.accessCards[i].clientName == tempArray[j]) gotDuplicate = true;
								}

								if (!gotDuplicate && customClaims.accessCards[i].clientName !== '' && customClaims.accessCards[i].clientName != undefined)
								{
									clientsForTitle += customClaims.accessCards[i].clientName+', ';
									tempArray.push(customClaims.accessCards[i].clientName);
								}
							}
						}

						for (let i = customClaims.accessCards.length-1; i >= 0; i--)
						{
							if (customClaims.accessCards[i].clientName === null) customClaims.accessCards.splice(i, 1);
						}


						// Remove comma on last entry
						clientsForTitle = clientsForTitle.substring(0, clientsForTitle.length-2);


						// ------------------------------------------
						//	If user is super admin, show super card
						// ------------------------------------------

						if (customClaims.superAdmin)
						{
							customClaims.accessCards.unshift(
							{
								clientName: 'Super Administrator',
								groupName: '',
								projectName: '',
								l: 'super' // access level
							});

							// Overwrite this when super admin
							clientsForTitle = 'Super Administrator';
						}

						


						// ------------------------------------------
						//	We want to reset open/closed state on items
						//  that was open in the expansion panel
						// ------------------------------------------

						let thisWasOpenInExpansionPanel = false;

						for (let i = 0; i < tempItemsWasOpen.length; i++)
						{
							if (tempItemsWasOpen[i] == user.auth.uid) thisWasOpenInExpansionPanel = true;
						}

						// ------------------------------------------
						//	Start pushing
						// ------------------------------------------

						tempUserList.push(
						{
							n: count++, // We just want a simple number to keep track of forms, id's are not safe to be used as property name appendixes
							id: user.auth.uid,
							name: user.auth.displayName,
							firstName: user.firestore.firstName,
							lastName: user.firestore.lastName,
							email: user.auth.email,
							disabled: user.disabled,
							customClaims: customClaims, 
							clientsListedforTitle: clientsForTitle,
							panelOpen: thisWasOpenInExpansionPanel,
						});
					});

					//this.agile.sortBy(this.userList, 'name');
					this.agile.sortBy(tempUserList, this.lastSortedBy);
					
					// Now update the real dataprovider
					this.userList = tempUserList;
					
				}
				else
				{
					this.$root.$alert("Error", result.data.error.message);
				}
				
			})
			.catch(er =>
			{
				this.$root.ai_app.showProgressWheel = false;
				this.$root.$alert("Error", er);
			});*/

		},

		// ----------------------------------
		//	Get readable access level
		// ----------------------------------

		getReadableAccessLevel(level) // array of user id's
		{
			if (!level)
			{
				return 'UNDEF';
			}
			else if (level == "super")
			{
				return 'SUPER';
			}
			else if (level.dev)
			{
				return 'DEV';
			}
			else if (level.adm)
			{
				return 'ADMIN';
			}
			else if (level.edi)
			{
				return 'EDITOR';
			}
			else if (level.rea)
			{
				return 'READER';
			}
			else if (level.gue)
			{
				return 'GUEST';
			}
			else
			{
				return '?';
			}
			
		},


		// ----------------------------------
		//	Disable users
		// ----------------------------------

		disableUsers(userIds) // array of user id's
		{
			// ----------------------------------
			//	First we warn about the operation
			// ----------------------------------

			const warnTitle = 'Disabling user'+((userIds.length > 1) ? 's' : '');
			const warnText = 'Disabled user will not be able to login or access the system in any way.';

			this.$root.$confirm(warnTitle, warnText)
			.then((confirm) =>
			{
				if (confirm)
				{
					// ----------------------------------
					//	Then if confirmed, go ahead
					// ----------------------------------

					this.$root.ai_app.showProgressWheel = true;
			
					const setUsersDisabledState = fb.functions.httpsCallable('setUsersDisabledState');

					setUsersDisabledState( { usersUids:userIds, disabledState:true } )
					.then(result =>
					{
						this.$root.ai_app.showProgressWheel = false;
						if (result.data.success)
						{
							this.selectedUsers = [];

							// Log this to console, we might have some errors, even some users got disabled, some might not. aiData will tell you.
							console.log("Updated disabled state", result.data.aiData);

							// Update list from server
							this.getUserList();
						}
						else
						{
							this.$root.$alert("Error", result.data.error.message);
						}
						
					})
					.catch(er =>
					{
						this.$root.ai_app.showProgressWheel = false;
						this.$root.$alert("Error", er);
					});
				}
			});

		},


		// ----------------------------------
		//	Save user
		// ----------------------------------

		saveUser(userProvided)
		{   
			if (this.$refs['editUserForm'+userProvided.n][0].validate())
			{
				userProvided.name = userProvided.firstName+" "+userProvided.lastName;

				//this.fireBaseInProgress = true;
				this.$root.ai_app.showProgressWheel = true;

				const updateUser = fb.functions.httpsCallable('updateUser');
				//console.log("*E Disabled:", userProvided.disabled)

				updateUser( { uid:userProvided.id, email:userProvided.email, firstName:userProvided.firstName, lastName:userProvided.lastName, disabled:userProvided.disabled } )
				.then(result =>
				{
					if (result.data.success)
					{
						this.$root.ai_app.snackbarText = 'User edited';
						this.$root.ai_app.snackbarTimeout = 4000;
						this.$root.ai_app.snackbar = true;
					}
					else
					{
						this.$root.$alert("Error", result.data.error.message);
					}
					
					this.$root.ai_app.showProgressWheel = false;
				})
				.catch(er =>
				{
					this.$root.$alert("Error", er.message);
					this.$root.ai_app.showProgressWheel = false;
				});
				
				
			}
		},

		// ----------------------------------
		//	Save user
		// ----------------------------------

		openChooseProject(uid)
		{
			this.$refs.chooseProject.open(uid);
		},


		// ----------------------------------
		//	Update user data when access addded
		// ----------------------------------

		handleAccessCardAdded()
		{
			// Todo: I guess we shouldn't have to download the entire user
			// list just to show that some access card on one user is updated...?
			this.getUserList();
		},


		// ----------------------------------
		//	Enable users
		// ----------------------------------

		enableUsers(userIds)
		{
			// ----------------------------------
			//	First we warn about the operation
			// ----------------------------------

			const warnTitle = 'Enabling user'+((userIds.length > 1) ? 's' : '');
			const warnText = 'Enabled users will be able to login and access the system again (according to their permissions).';

			this.$root.$confirm(warnTitle, warnText)
			.then((confirm) =>
			{
				if (confirm)
				{
					// ----------------------------------
					//	Then if confirmed, go ahead
					// ----------------------------------

					this.$root.ai_app.showProgressWheel = true;
					
					const setUsersDisabledState = fb.functions.httpsCallable('setUsersDisabledState');

					setUsersDisabledState( { usersUids:userIds, disabledState:false } )
					.then(result =>
					{
						this.$root.ai_app.showProgressWheel = false;
						if (result.data.success)
						{
							this.selectedUsers = [];

							// Log this to console, we might have some errors, even some users got re-enabled, some might not. aiData will tell you.
							console.log("Updated disabled state", result.data.aiData);

							// Update list from server
							this.getUserList();
						}
						else
						{
							this.$root.$alert("Error", result.data.error.message);
						}
						
					})
					.catch(er =>
					{
						this.$root.ai_app.showProgressWheel = false;
						this.$root.$alert("Error", er);
					});
				}
			});
		},
		

		// ----------------------------------
		//	Delete users
		// ----------------------------------

		deleteUsers(userIds) // array of user id's to delete
		{

			// ----------------------------------
			//	First we warn about the operation
			// ----------------------------------

			const warnTitle = 'Deleting user'+((userIds.length > 1) ? 's' : '');
			const warnText = 'Deleting users are permanent. Do you really want to delete selected users?';

			this.$root.$confirm(warnTitle, warnText, { color: 'error' })
			.then((confirm) =>
			{
				if (confirm)
				{
					// ----------------------------------
					//	Then if confirmed, go ahead
					// ----------------------------------

					this.$root.ai_app.showProgressWheel = true;
			
					const deleteUsers = fb.functions.httpsCallable('deleteUsers');

					deleteUsers(userIds)
					.then(result =>
					{
						this.$root.ai_app.showProgressWheel = false;
						if (result.data.success)
						{
							this.selectedUsers = [];

							// Log this to console, we might have some errors, even some users got deleted, some might not,
							// or auth/data object might have failed to delete. aiData will tell you.
							console.log("Deleted user", result.data.aiData);

							// Update list from server
							this.getUserList();
						}
						else
						{
							this.$root.$alert("Error", result.data.error.message);
						}
						
					})
					.catch(er =>
					{
						this.$root.ai_app.showProgressWheel = false;
						this.$root.$alert("Error", er);
					});
				}
			});

		},

		// ----------------------------------
		//	Make super admin Todo: This was very fast made
		// ----------------------------------

		makeSuperAdmin(uid)
		{
			const makeSuperAdmin = fb.functions.httpsCallable('makeSuperAdmin');

			makeSuperAdmin(uid)
			.then(result =>
			{
				console.log(result);

				// Refresh user list to show super admin card
					this.getUserList();
			})
			.catch(er =>
			{
				console.log(er);
			});
		}

	},

	beforeDestroy()
	{
		this.panel = [];
		//console.log('DESGTROY');
		agileFb.updateUserPageList = null;
	},

	// ----------------------------------
	//	VUE: Components
	// ----------------------------------

	components:
	{
		ChooseProjectForAccess,
	}
}
</script>